import React, { Component } from "react";

import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import queryString from "query-string";
import {
  getMediaBuyerBudgets,
  deleteMediaBuyerBudget,
  getMediaBuyerDataForAdd,
  addMediaBuyerBudget,
  getFilteredBudgets,
} from "../../../store/mediabuyers/mediabuyerbudget/actions";
import { getOffers } from "../../../store/offers/actions";
import MediaBuyingBudgetsModal from "./MediaBuyingBudgetsModal";
import FormToFilter from "../../../components/forms/FormToFilter";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class MediaBuyerBudgets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      mediaBuyers: null,
      offerTypes: null,
      deleteAlert: null,
      viewAddBudget: false,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    let data = this.props.data;
    let parsedSearch = queryString.parse(this.props.history.location.search);

    data.page = parsedSearch.page || 1;
    data.sizePerPage = parsedSearch.size || data.sizePerPage;

    let formQueryString = queryString.stringify(
      Object.assign(parsedSearch, {
        page: parsedSearch.page,
        size: parsedSearch.size,
      })
    );

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);

    this.props.getMediaBuyerDataForAdd();
    this.props.getOffers({
      ...this.props.offers,
      is_main: false,
    });
    this.props.getMediaBuyerBudgets(data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { dataForAddBudget } = this.props;
    if (prevProps.dataForAddBudget !== dataForAddBudget) {
      this.setState({
        offerTypes: this.props.offers,
        mediaBuyers: dataForAddBudget.mediaBuyers,
      });
    }
  }

  handleTableChange = data => {
    let currentSearch = queryString.parse(this.props.history.location.search);

    let formQueryString = queryString.stringify(
      Object.assign(currentSearch, {
        page: data.page,
        size: data.sizePerPage,
      })
    );
    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.getMediaBuyerBudgets(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget,
    }));
  };

  render() {
    const onClickEdit = (e, row) => {
      this.props.history.push(`/media-buyer-budget/${row.id}`);
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickEdit(e, row)}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.media_buyer}"!`,
          onConfirm: () => {
            this.props.deleteMediaBuyerBudget(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <>
          {this.props.permissions?.["change_mediabuyerbudgetmodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickEdit(e, row)}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </button>
          )}
          {this.props.permissions?.["delete_mediabuyerbudgetmodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    const columns = [
      {
        dataField: "media_buyer",
        text: "Media buyer name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "media_buyer"),
      },
      {
        dataField: "offer",
        text: "Offer",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "offer"),
      },
      {
        dataField: "budget",
        text: "Budget",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "budget"),
      },
      {
        dataField: "date_range",
        text: "Date range",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "date_range"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <>
        {this.props.data !== null && (
          <React.Fragment>
            {this.state.viewAddBudget && (
              <MediaBuyingBudgetsModal
                toggle={this.toggleViewAddBudgetModal}
                isOpen={this.state.viewAddBudget}
                data={this.props.dataForAddBudget}
                currentMedia={this.props.data}
                addMediaBuyerBudget={this.props.addMediaBuyerBudget}
                offers={this.props.offers}
              />
            )}

            <div className="page-content">
            <ModifiedMetaTags title="Media buyer budgets | Mobihunter" />

              <Container fluid>
                <Breadcrumbs
                  title="Dashboard"
                  breadcrumbItem="Media buyer budgets"
                  link="/dashboard"
                />

                {this.state.deleteAlert && (
                  <SweetAlert
                    showCancel
                    confirmBtnText="Delete"
                    cancelBtnText="Cancel"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle=""
                    title={this.state.deleteAlert.title}
                    onCancel={() => this.handleChangeDeleteAlert(null)}
                    onConfirm={this.state.deleteAlert.onConfirm}
                  >
                    <p>Are you sure want to delete this media buyer?</p>
                  </SweetAlert>
                )}

                <FormToFilter
                  data={this.props.data}
                  dataForAddBudget={this.props.dataForAddBudget}
                  getFilteredRequest={this.props.getFilteredBudgets}
                  offers={this.props.offers}
                  FilterType="budget"
                  history={this.props.history}
                />
                <Row>
                  <Col className="col-12">
                    <Card>
                      <CardBody>
                        <RemoteTable
                          onTableChange={this.handleTableChange}
                          columns={columns}
                          data={this.props.data}
                          loading={this.props.loading}
                        >
                          {this.props.permissions?.[
                            "add_mediabuyerbudgetmodel"
                          ] && (
                            <Button
                              type="button"
                              color="success"
                              className="btn-rounded mb-2 me-2"
                              onClick={this.toggleViewAddBudgetModal}
                            >
                              <i className="mdi mdi-plus me-1" /> Add media
                              buyer budget
                            </Button>
                          )}
                        </RemoteTable>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </React.Fragment>
        )}
      </>
    );
  }
}

const LegalNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

MediaBuyerBudgets.propTypes = {
  history: PropTypes.any,
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  getMediaBuyerBudgets: PropTypes.func.isRequired,
  deleteMediaBuyerBudget: PropTypes.func.isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  addMediaBuyerBudget: PropTypes.func.isRequired,
  getFilteredBudgets: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  dataForAddBudget: PropTypes.object,
  isError: PropTypes.bool,
  getOffers: PropTypes.func.isRequired,
  offers: PropTypes.any.isRequired,
};

const mapStateToProps = state => ({
  offers: state.Offers.offers,
  data: state.MediaBuyerBudgets.data,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
  loading: state.MediaBuyerBudgets.loading,
  permissions: state.User.permissions,
  isError: state.MediaBuyerBudgets.isError,
});

export default connect(mapStateToProps, {
  getMediaBuyerBudgets,
  deleteMediaBuyerBudget,
  addMediaBuyerBudget,
  getFilteredBudgets,
  getMediaBuyerDataForAdd,
  getOffers,
})(MediaBuyerBudgets);
